import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AppLayout } from "./components/AppLayout";
import { ErrorBoundary } from "./components/ErrorBoundary";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import VendorPage from "./pages/Vendor";
import VendorDetailPage from "./pages/VendorDetail";
import JenisKainPage from "./pages/JenisKain";
import PeralatanPage from "./pages/Peralatan";
import ProdukPage from "./pages/Produk";
import UsersPage from "./pages/Users";
import AccountCenterPage from "./pages/AccountCenter";
import PengaturanPage from "./pages/Pengaturan";
import BackupDataPage from "./pages/BackupData";
import KonfigurasiAIPage from "./pages/KonfigurasiAI";
import RiwayatTerhapusPage from "./pages/RiwayatTerhapus";

import SPKPage from "./pages/SPK";
import SPKDetailPage from "./pages/SPKDetail";
import BonKainPage from "./pages/BonKain";
import BonPeralatanPage from "./pages/BonPeralatan";
import SetorBarangPage from "./pages/SetorBarang";
import KasbonPage from "./pages/Kasbon";
import QCPage from "./pages/QC";
import RejectPerbaikanPage from "./pages/RejectPerbaikan";
import InvoicePage from "./pages/Invoice";
import InvoiceCreatePage from "./pages/InvoiceCreate";
import InvoiceDetailPage from "./pages/InvoiceDetail";
import LaporanExportPage from "./pages/LaporanExport";
import PublicInvoicePage from "./pages/PublicInvoice";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/public/invoice/:token" element={<PublicInvoicePage />} />
                        <Route
                            element={
                                <ProtectedRoute>
                                    <AppLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="/" element={<Navigate to="/dashboard" replace />} />
                            <Route path="/dashboard" element={<ErrorBoundary label="Dashboard"><Dashboard /></ErrorBoundary>} />
                            <Route path="/master-vendor" element={<ErrorBoundary label="Master Vendor"><VendorPage /></ErrorBoundary>} />
                            <Route path="/vendor/:id" element={<ErrorBoundary label="Vendor Detail"><VendorDetailPage /></ErrorBoundary>} />
                            <Route path="/vendor" element={<ErrorBoundary label="Vendor"><VendorPage /></ErrorBoundary>} />
                            <Route path="/buku-vendor" element={<Navigate to="/dashboard" replace />} />

                            {/* Transaksi — semua authenticated user bisa akses */}
                            <Route path="/spk" element={<SPKPage />} />
                            <Route path="/spk/:id" element={<SPKDetailPage />} />
                            <Route path="/bon-kain" element={<BonKainPage />} />
                            <Route path="/bon-peralatan" element={<BonPeralatanPage />} />
                            <Route path="/setor-barang" element={<SetorBarangPage />} />
                            <Route path="/qc" element={<QCPage />} />
                            <Route path="/reject-perbaikan" element={<RejectPerbaikanPage />} />
                            <Route path="/kasbon" element={<KasbonPage />} />
                            <Route path="/invoice" element={<InvoicePage />} />
                            <Route path="/invoice/new" element={<InvoiceCreatePage />} />
                            <Route path="/invoice/:id" element={<InvoiceDetailPage />} />
                            <Route path="/laporan" element={<LaporanExportPage />} />

                            {/* Master — semua user */}
                            <Route path="/jenis-kain" element={<JenisKainPage />} />
                            <Route path="/peralatan" element={<PeralatanPage />} />
                            <Route path="/produk" element={<ProdukPage />} />

                            {/* Pengaturan — semua user bisa akses, kecuali Account Center (owner only) */}
                            <Route path="/pengaturan" element={<PengaturanPage />} />
                            <Route path="/konfigurasi-ai" element={<KonfigurasiAIPage />} />
                            <Route path="/backup-data" element={<BackupDataPage />} />

                            {/* Riwayat Terhapus — OWNER ONLY (soft delete trash) */}
                            <Route
                                path="/riwayat-terhapus"
                                element={
                                    <ProtectedRoute ownerOnly>
                                        <RiwayatTerhapusPage />
                                    </ProtectedRoute>
                                }
                            />

                            {/* Account Center — OWNER ONLY */}
                            <Route
                                path="/account-center"
                                element={
                                    <ProtectedRoute ownerOnly>
                                        <AccountCenterPage />
                                    </ProtectedRoute>
                                }
                            />

                            {/* Legacy users page — owner only */}
                            <Route
                                path="/users"
                                element={
                                    <ProtectedRoute ownerOnly>
                                        <UsersPage />
                                    </ProtectedRoute>
                                }
                            />
                        </Route>
                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
